module.exports = __webpack_public_path__ + "static/img/ent-46.521b37a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-46.jpg
// module id = 6NLQ
// module chunks = 52